import React, { useState } from 'react';
import { Button } from 'reactstrap';

// Sample usage:
{
  /* <ConfirmationModal
  isOpen={deleteConfirmationOpen}
  onClose={() => setDeleteConfirmationOpen(false)}
  onConfirm={() => {
    const { patientName, conversationIds } = patientToDelete;
    deletePatientAndConversations(patientName, conversationIds);
  }}
>
  Are you sure you want to delete this patient and all of their conversations?
</ConfirmationModal> */
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  children,
  confirmButtonText = 'Delete',
  cancelButtonText = 'Cancel',
  showDontShowAgain = false,
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(dontShowAgain);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="mb-4">{children}</div>
        {showDontShowAgain && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '12px',
            }}
          >
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#555',
              }}
            >
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
              />
              Don't show this again
            </label>
          </div>
        )}
        <div className="modal-buttons">
          <Button color="danger" onClick={handleConfirm}>
            {confirmButtonText}
          </Button>
          {onClose && (
            <Button color="primary" onClick={onClose}>
              {cancelButtonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
